import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  height: number;
}

export const AccordionPanelWrap = styled.div<IProps>`
  overflow: hidden;
  //max-height: ${props => mixin.pxToVw(String(props.height))};
  max-height: ${props => props.height}px;
  transition: max-height 0.25s linear 0s;
  will-change: auto;

  &[hidden] {
    display: block;
    max-height: 0 !important;
  }
`;
